<script setup lang="ts">
import { Toaster } from '@/components/ui/sonner';

const userStore = useUserStore();

onMounted(() => {
  userStore.loadFromStorage();
});
</script>

<template>
  <NuxtLoadingIndicator />
  <ClientOnly>
    <Toaster
      rich-colors
      :theme="$colorMode.value == 'dark' ? 'dark' : 'light'"
    />
  </ClientOnly>

  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
